import { getAllAuthority, getAllAuthorityData } from "@/api/authority/authority";
import type { MainMenu } from "@/types/common/common.d";
import { adminRouters, merchantRouters } from "@/router/asyncRoutes";
import { useMenusStore } from "@/store/menu";

export const updateMenu = async () => {
    try {
        const result = await getAllAuthority();
        return result as MainMenu[];
    } catch (error) { }
};

export const getMenu = async () => {
    try {
        const result = await getAllAuthorityData();
        if (!result || !result.length) {
            return [];
        }
        const menus = useMenusStore();
        let arr = result;
        menus.setLicensed(arr.find((item) => (item.authoritySn === "licensed" && item.isShow === 1)) ? true : false)        
        const adminType = localStorage.getItem("adminType");        
        if (adminType !== "shop") {
            arr = [...arr, { authoritySn: "accountEditingManage", authorityName: "个人中心" }, { authoritySn: "notFound" }];
        } else {
            arr = [...arr,{ authoritySn: "accountEditingManage", authorityName: "账户列表" }, { authoritySn: "notFound" }];
        }
        const routes = filterRoutesByAuthority(adminType !== "shop" ? adminRouters : merchantRouters, arr) || [];
        return routes
    } catch (error) { }
};

/**
 * 路由项类型定义
 */
interface RouteItem {
    path: string;
    name: string;
    component?: any;
    redirect?: string;
    meta?: {
        title?: string;
        is404?: boolean;
        isShowInHeader?: boolean;
        queryParam?: string;
        [key: string]: any;
    };
    children?: RouteItem[];
    [key: string]: any;
}

/**
 * 权限项类型定义
 */
interface AuthorityItem {
    authoritySn: string;
    authorityName: string;
    authorityIco: string;
    isShow: boolean;
}

/**
 * 根据 authority 数组匹配路由
 * @param routes 原始路由配置
 * @param authNames 权限名称数组
 * @returns 匹配后的路由列表
 */
function filterRoutesByAuthority(routes: RouteItem[], authorities: AuthorityItem[]): RouteItem[] {
    const routers: RouteItem[] = [];
    // 创建权限映射，方便查找
    const authMap: Record<string, AuthorityItem> = {};
    authorities.forEach((auth) => {
        authMap[auth.authoritySn] = auth;
    });
    // 递归查找匹配的路由
    function findMatchedRoutes(routeList: RouteItem[], parentPath: string = "", resultContainer?: RouteItem[]): void {
        routeList.forEach((route, index) => {
            // 检查当前路由是否在权限列表中
            if (authMap[route.name]) {
                const filteredRoute: RouteItem = { ...route };

                filteredRoute.meta = { ...(filteredRoute.meta || {}), ...authMap[route.name], current: true };

                if (route.children && route.children.length) {
                    filteredRoute.children = [];
                    findMatchedRoutes(route.children, route.path, filteredRoute.children);
                }

                if (resultContainer) {
                    resultContainer.push(filteredRoute);
                } else {
                    routers.push(filteredRoute);
                }
            }
            // 即使当前路由不匹配，仍需检查其子路由
            else if (route.children && route.children.length) {
                const matchedChildren: RouteItem[] = [];
                findMatchedRoutes(route.children, route.path, matchedChildren);

                // 如果有匹配的子路由，则保留父路由
                if (matchedChildren.length > 0) {
                    const filteredRoute: RouteItem = { ...route, children: matchedChildren };
                    if (resultContainer) {
                        resultContainer.push(filteredRoute);
                    } else {
                        routers.push(filteredRoute);
                    }
                }
            }
        });
    }

    findMatchedRoutes(routes);
    return routers;
}
